import { useLocation } from "react-router-dom";
import PageMeta from '../components/base/PageMeta';

export default function NotFound() {
  const location = useLocation();
  
  return (
    <>
      <PageMeta
        title="Page Not Found | LUCENDO"
        description="The page you are looking for could not be found. Return to LUCENDO's homepage to explore premium Italian coffee and HoReCa solutions."
      />
      <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
        <span className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
          404
        </span>
        <div className="relative z-10">
          <h1 className="text-xl md:text-2xl font-semibold mt-6">Page Not Found</h1>
          <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
          <p className="mt-4 text-lg md:text-xl text-gray-500">The page you are looking for does not exist. Return to our homepage to explore premium Italian coffee and HoReCa solutions.</p>
        </div>
      </div>
    </>
  );
}